import { Slide, composeSlides } from '@features/powerpoint';
import { DEFAULT_SLIDE_MASTER } from '../../../slides/slide-master';
import { CampaignAnalyticsReport } from '@components/Dashboard/CampaignAnalytics/slice/schema';
import {
  ChartWithBackgroundOptions,
  chartWithBackground,
} from './more-stats/chart-with-background';
import { contentSlideTitleText } from '../../../slides/content-slide-title-text';
import { proximityToHomeChartData } from './more-stats/proximity-to-home-chart-data';
import { visitsByTimeOfDayChartData } from './more-stats/visits-by-time-of-day-chart-data';
import { visitsByDayOfWeekChartData } from './more-stats/visits-by-day-of-week-chart-data';
import { timeToFirstVisitChartData } from './more-stats/time-to-first-visit-chart-data';

export const buildChartMetadata = (options: MoreStatsSlideOptions): Slide[] => {
  const chartMetadata: ChartMetadata[] = [
    {
      chartTitle: 'Proximity to Home',
      chartUnits: '%',
      chartData: proximityToHomeChartData(options.proximityToHome),
    },
    {
      chartTitle: 'Visits by Time of Day',
      chartUnits: '%',
      chartData: visitsByTimeOfDayChartData(options.visitsByHourOfDay),
    },
    {
      chartTitle: 'Visits by Day of Week',
      chartUnits: 'Visits',
      chartData: visitsByDayOfWeekChartData(options.visitsByDayOfWeek),
    },
    {
      chartTitle: 'Time to First Visit',
      chartUnits: '%',
      chartData: timeToFirstVisitChartData(options.timeToFirstVisitByDay),
    },
  ];
  return chartMetadata
    .filter(data => data.chartData.length > 0)
    .map((metadata, chartIndex) =>
      chartWithBackground({
        ...metadata,
        chartIndex,
        styleMetadata: options.styleMetadata,
      })
    );
};

type ChartMetadata = Omit<ChartWithBackgroundOptions, 'chartIndex'>;

type MoreStatsSlideOptions = {
  proximityToHome: CampaignAnalyticsReport['proximityToHome'];
  visitsByHourOfDay: CampaignAnalyticsReport['visitsByHourOfDay'];
  visitsByDayOfWeek: CampaignAnalyticsReport['visitsByDayOfWeek'];
  timeToFirstVisitByDay: CampaignAnalyticsReport['timeToFirstVisitByDay'];
  styleMetadata?: ChartWithBackgroundOptions['styleMetadata'];
};

export const moreStatsSlide = (options: MoreStatsSlideOptions): Slide => {
  return composeSlides(
    {
      slideMaster: DEFAULT_SLIDE_MASTER,
      texts: [contentSlideTitleText('<lci>More</lci> <b>Stats</b>')],
    },
    ...buildChartMetadata(options)
  );
};
